<!-- 未完成/审核不通过进来 -->
<template>
	<div class="home">
		<van-tabs @click="onClick" class="tabsList" color="#FF6900" v-model="active">
		  <van-tab title="申请详情"></van-tab>
		  <!-- <van-tab title="申请列表"></van-tab> -->
		</van-tabs>
		<div class="box" v-show="showForm == true">
			<van-form @submit="onSubmit">
				<div class="formtitle">单位信息</div>
				<van-field
					@click="showDialog2"
					readonly
					clickable
					:value="companyname"
					name="单位名称"
					label="单位名称"
					placeholder="点击选择单位名称"
					:rules="[{ required: false, message: '请填写单位名称' }]"
				/>
				<van-field
					@click="showDialog"
				  readonly
				  clickable
				  name="picker"
				  :value="unionsname"
				  label="所属工会"
				  placeholder="点击选择所属工会"
					:rules="[{ required: false, message: '请选择所属工会' }]"
				/>
<!-- 				<van-popup v-model="showPicker" position="bottom">
				  <van-picker
				    show-toolbar
				    :columns="columns"
				    @confirm="onConfirm"
				    @cancel="showPicker = false"
				  />
				</van-popup> -->
				<van-field
				  readonly
				  clickable
				  name="picker"
				  :value="company_nature"
				  label="单位性质"
				  placeholder="点击选择单位性质"
				  @click="showPicker2 = true"
					:rules="[{ required: true, message: '请选择单位性质' }]"
				/>
				<van-popup v-model="showPicker2" position="bottom">
				  <van-picker
				    show-toolbar
				    :columns="columns2"
				    @confirm="onConfirm2"
				    @cancel="showPicker2 = false"
				  />
				</van-popup>
				<van-field
				  readonly
				  clickable
				  name="picker"
				  :value="company_scale"
				  label="单位规模"
				  placeholder="点击选择单位规模"
				  @click="showPicker3 = true"
					:rules="[{ required: true, message: '请选择单位规模' }]"
				/>
				<van-popup v-model="showPicker3" position="bottom">
				  <van-picker
				    show-toolbar
				    :columns="columns3"
				    @confirm="onConfirm3"
				    @cancel="showPicker3 = false"
				  />
				</van-popup>
				<van-field
					v-model="company_num"
					name="单位人数"
					label="单位人数"
					placeholder="单位人数"
					:rules="[{ required: true, message: '请填写单位人数' }]"
				/>
				<div class="formtitle">联系信息</div>
				<van-field
					v-model="company_contactname"
					name="单位联系人"
					label="单位联系人"
					placeholder="单位联系人"
					:rules="[{ required: true, message: '请填写单位联系人' }]"
				/>
				<van-field
					v-model="company_contactmobile"
					name="联系人电话"
					label="联系人电话"
					placeholder="联系人电话"
					:rules="[{ required: true, message: '请填写联系人电话' }]"
				/>
				<van-field
					v-model="company_contactemail"
					name="联系人邮箱"
					label="联系人邮箱"
					placeholder="联系人邮箱"
					:rules="[{ required: true, message: '请填写联系人邮箱' }]"
				/>
				<div class="tips">(审核通过后，给填写邮箱发送包括相关资料)</div>
				<!-- <van-field
					v-model="industry"
					name="所属行业"
					label="所属行业"
					placeholder="所属行业"
					:rules="[{ required: true, message: '请填写所属行业' }]"
				/> -->
				<div class="formtitle">详细信息</div>
				<van-field
				  readonly
				  clickable
				  name="picker"
				  :value="industry"
				  label="所属行业"
				  placeholder="点击选择所属行业"
				  @click="showPicker8 = true"
				/>
				<van-popup v-model="showPicker8" position="bottom">
				  <van-picker
				    show-toolbar
				    :columns="columns8"
				    @confirm="onConfirm8"
				    @cancel="showPicker8 = false"
				  />
				</van-popup>
				<van-field
				  readonly
				  clickable
				  name="area"
				  :value="address_01"
				  label="单位地址"
				  placeholder="点击选择单位地址"
				  @click="showArea = true"
					:rules="[{ required: true, message: '请选择单位地址' }]"
				/>
				<van-popup v-model="showArea" position="bottom">
				  <van-area
				    :area-list="areaList"
				    @confirm="onConfirm4"
				    @cancel="showArea = false"
				  />
				</van-popup>
				<van-field
					v-model="address_detail"
					name="详细地址"
					label="详细地址"
					placeholder="详细地址"
					:rules="[{ required: true, message: '请填写详细地址' }]"
				/>
				<div style="margin: 16px;">
					<van-button class="btn002" round block type="primary" native-type="submit">保存并下一步</van-button>
				</div>
			</van-form>
			<van-overlay :show="isdialog3" @click="isdialog3 = false" >
				<div class="wrapper" @click.stop>
					<div class="block">
						<div class="title001">选择企业</div>
						<div class="searchBox">
							<van-search @search="onSearch3" v-model="searchContent3" placeholder="请输入搜索关键词" />
						</div>
						<div class="unionsList">
							<div class="notdata" v-if="unionsList3.length == 0">暂无企业</div>
							<div v-else class="unionsList-item" v-for="(item, index) in unionsList3" @click="selectedUnions3(item)">
								{{ item.name }}
							</div>
						</div>
						<div class="addUnions">
							<van-button @click="isdialog3 = false" class="addUnions-btn" type="default">关闭</van-button>
							<!-- <van-button class="addUnions-btn" type="primary" @click="addUnionsDialog">新增工会</van-button> -->
						</div>
					</div>
				</div>
			</van-overlay>
			<van-overlay :show="isdialog" @click="isdialog = false" >
				<div class="wrapper" @click.stop>
					<div class="block">
						<div class="title001">选择工会</div>
						<div class="searchBox">
							<van-search @search="onSearch" v-model="searchContent" placeholder="请输入搜索关键词" />
						</div>
						<div class="unionsList" @scroll="scrollEvent">
							<div class="notdata" v-if="unionsList.length == 0">暂无工会</div>
							<div v-else class="unionsList-item" v-for="(item, index) in unionsList" @click="selectedUnions(item)">
								{{ item.name }}
							</div>
						</div>
						<div class="addUnions">
							<van-button @click="isdialog = false" class="addUnions-btn" type="default">关闭</van-button>
							<van-button class="addUnions-btn" type="primary" @click="addUnionsDialog">新增工会</van-button>
						</div>
					</div>
				</div>
			</van-overlay>
			<van-overlay :show="isdialog2" @click="isdialog2 = false" >
				<div class="wrapper" @click.stop>
					<div class="block">
						<div class="title001">新增工会</div>
<!-- 						<div class="searchBox">
							<van-search v-model="searchContent" placeholder="请输入搜索关键词" />
						</div> -->
						<div class="inputBox">
							<van-field border v-model="new_unions" label="工会" placeholder="请输入工会名称" />
						</div>
						<div class="addUnions">
							<van-button @click="isdialog2 = false" class="addUnions-btn" type="default">关闭</van-button>
							<van-button class="addUnions-btn" type="primary" @click="comfirmInfo">确认提交</van-button>
						</div>
					</div>
				</div>
			</van-overlay>
		</div>
		
		<div class="box" v-show="showForm == false">
			<van-form @submit="onSubmit2">
				<van-field
					v-model="measure"
					name="建设面积"
					label="建设面积"
					placeholder="建设面积"
					:rules="[{ required: true, message: '请填写建设面积' }]"
				/>
				<van-field
				  readonly
				  clickable
				  name="datetimePicker"
				  :value="date01"
				  label="时间选择"
				  placeholder="点击选择时间"
				  @click="showPicker4 = true"
					:rules="[{ required: true, message: '请选择时间' }]"
				/>
				<van-popup v-model="showPicker4" position="bottom">
				  <van-datetime-picker
				    type="date"
						:min-date="minDate"
						:formatter="formatter"
				    @confirm="onConfirm5"
				    @cancel="showPicker4 = false"
				  />
				</van-popup>
				<van-field
				  readonly
				  clickable
				  name="picker"
				  :value="apply_type"
				  label="申请类型"
				  placeholder="点击选择申请类型"
				  @click="showPicker01 = true"
					:rules="[{ required: true, message: '请选择申请类型' }]"
				/>
				<van-popup v-model="showPicker01" position="bottom">
				  <van-picker
				    show-toolbar
				    :columns="columns_01"
				    @confirm="onConfirm01"
				    @cancel="showPicker01 = false"
				  />
				</van-popup>
				<van-field
					v-model="address01"
					name="建设地址"
					label="建设地址"
					placeholder="建设地址"
					:rules="[{ required: true, message: '请填写建设地址' }]"
				/>
				<van-field 
					name="checkboxGroup" 
					label="预购设备"
					:rules="[{ required: true, message: '请勾选预购设备' }]"
				>
				  <template #input>
				    <van-checkbox-group v-model="checkboxGroup" direction="horizontal">
				      <van-checkbox v-for="(item, index) in deviceList" style="margin-bottom: .1rem;width: 100%;" :name="item.id" shape="square">{{ item.title }}</van-checkbox>
				      <!-- <van-checkbox style="margin-bottom: .2rem;" name="2" shape="square">复选框 2</van-checkbox>
							<van-checkbox style="margin-bottom: .2rem;" name="3" shape="square">复选框 2</van-checkbox>
							<van-checkbox style="margin-bottom: .2rem;" name="4" shape="square">复选框 2</van-checkbox> -->
				    </van-checkbox-group>
				  </template>
				</van-field>
				<!-- <video 
				style="width: 100px; height: 100px;"
				controls="controls"
				src="https://oss.mcloud.moveclub.cn/movexcxstore/20220314/GWamG3kBd7.mp4">
				</video> -->
				<van-field
					v-model="deviceinput"
					name="原有设备"
					label="原有设备"
					type="textarea"
					rows="2"
					maxlength="50"
					placeholder="原有设备,若不填写默认无"
					show-word-limit
					:rules="[{ required: false, message: '请填写原有设备' }]"
				/>
				<van-field 
					name="uploader" 
					label="营业执照"
					:rules="[{ required: true, message: '上传营业执照' }]"
					>
				  <template #input>
						<UploadImage :fileList="fileList"  class="jo_up" :item="item" @setUrl="setUrl" />
				    <!-- <van-uploader v-model="uploader" /> -->
				  </template>
				</van-field>
				<div class="refuseBox" v-if="status == '4'">
					不通过原因：{{ refuse_reason == "" ? '暂无' : refuse_reason }}
				</div>
				<div class="checkBoxNew">
					<van-checkbox v-model="checked"></van-checkbox>
					<div class="checkBoxNew-text">提交信息属实，并同意<span>驿站运营承诺书</span></div>
				</div>
				<div style="margin: 16px; display: flex;">
					<van-button round block type="default" native-type="button" @click="backBtn">返回上一步</van-button>
					<van-button class="btn002" round block type="primary" native-type="submit">提交申请</van-button>
				</div>
			</van-form>
			
		</div>
	</div>
</template>

<script>
import UploadImage from "@/views/Unions/components/upload";
	
export default {
	components: {
	  UploadImage
	},
	data(){
		return {
			minDate: new Date(2022, 2, 15),
			
			
			item:{
			    num:1,
			    style:true
			},
			active: 0,
			
			columns: ['徐汇区工会', '杨浦区工会', '浦东新区工会', '松江区工会', '其它'],
			showPicker: false,
			
			columns2: ['国企', '民营', '行政单位', '事业单位', '外商独资', '合资企业', '个体户'],
			showPicker2: false,
			
			columns3: ['微型企业', '小型企业', '中型企业', '大型企业'],
			showPicker3: false,
			
			showPicker4: false,
			
			columns_01: ['大型（200㎡以上）', '中型（150-199㎡）', '小型（50-149㎡）'],
			showPicker01: false,
			
			showPicker8: false,
			columns8: [
				{
					id: 1,
					text: '浙江',
					children: [
						{
							id: 2,
							text: '杭州',
						},
						{
							id: 3,
							text: '温州',
						},
					],
				},
				{
					id:9,
					text: '福建',
					children: [
						{
							id:10,
							text: '福州',
						},
						{
							id:11,
							text: '厦门',
						},
					],
				},
			],
			
			deviceList: [],
			
			areaList: {
				province_list: {
					310000: '上海市',
				},
				city_list: {
					310100: '上海市',
				},
				county_list: {
					310101:"黄浦区",
					310104:"徐汇区",
					310105:"长宁区",
					310106:"静安区",
					310107:"普陀区",
					310109:"虹口区",
					310110:"杨浦区",
					310112:"闵行区",
					310113:"宝山区",
					310114:"嘉定区",
					310115:"浦东新区",
					310116:"金山区",
					310117:"松江区",
					310118:"青浦区",
					310120:"奉贤区",
					310151:"崇明县"
				},
			}, // 数据格式见 Area 组件文档
			showArea: false,
			
			
			companyname: '',
			unionsname: '',
			unionsid: '',
			company_nature: '',
			company_scale: '',
			company_num: '',
			company_contactname:'',
			company_contactmobile: '',
			company_contactemail: '',
			industry: '',
			industry_id: '',
			address_01: '',
			address_detail: '',
			
			measure: '',
			date01: '',
			apply_type: '',
			address01: '',
			checkboxGroup: [],
			deviceinput: '',
			url: '',
			fileList: [],
			
			checked: true,
			id: '',
			showForm: true,
			
			
			searchContent: '',
			isdialog: false,
			unionsList: [],
			new_unions: '',
			isdialog2: false,
			page: 1,
			page_size: 40,
			
			
			
			status: '',
			refuse_reason: '',
			
			unionsList3: [],
			searchContent3: '',
			isdialog3: false,
		}
	},
	mounted() {
		var phone = localStorage.getItem('mobile')
		if(phone == '' || phone == null || phone == undefined){
			this.$router.push({
				name: 'unionslogin'
			})
			return
		}
		this.getConfigData()
		
		this.status = this.$route.query.status
		this.id = this.$route.query.id
		// console.log(this.id, this.status, '--0')
		this.showForm = false // 展示第二步
		var data = {
			id: this.id
		}		
		this.getData(data)
	},
	methods: {
		// 获取详情
		getData(data){			
			this.$api.unions
				.getDetail(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						this.refuse_reason = res.data.refuse_reason
						var json1 = ''
						if(res.data.apply_one != ''){
							json1 = JSON.parse(res.data.apply_one) 
							this.companyname = json1.company_name
							this.unionsname = json1.organize_name
							this.unionsid = json1.organize_id
							this.company_nature = json1.type
							this.company_scale = json1.company_scale
							this.company_num = json1.person_num
							this.company_contactname = json1.contact
							this.company_contactmobile = json1.contact_mobile
							this.company_contactemail = json1.contact_email
							this.industry = json1.industry
							this.industry_id = json1.industry_id
							this.address_01 = json1.district
							this.address_detail = json1.company_address
						}
						var json2 = ''
						if(res.data.apply_two != ''){
							json2 = JSON.parse(res.data.apply_two)
							console.log(json2)	
							this.measure = json2.area
							this.date01 = json2.build_start_time
							this.apply_type = json2.stadium_scale
							this.address01 = json2.stadium_address
							this.checkboxGroup = json2.equipment
							this.deviceinput = json2.old_equipment
							this.url = json2.business_license
							this.fileList = [{
								url: json2.business_license
							}]
							// measure: '',
							// date01: '',
							// apply_type: '',
							// address01: '',
							// checkboxGroup: [],
							// deviceinput: '',
							// url: '',
						}
						
					}
				})
		},
		
		// 获取行业、设备数据
		getConfigData(){
			this.$api.unions
				.getConfigData1({page: 1, page_size: 9999})
				.then((res) => {
					if (res.status * 1 === 200) {
						this.deviceList = res.data.list
						res.data.list.forEach(item => {
							if(item.title == '智能体测机'){
								this.checkboxGroup.push(item.id)
							}
							if(item.title == '智能打卡机'){
								this.checkboxGroup.push(item.id)
							}
						})
					}
				})
				// 行业
			this.$api.unions
				.getConfigData2({page: 1, page_size: 9999})
				.then((res) => {
					if (res.status * 1 === 200) {
						var arr = []
						res.data.list.forEach(item => {
							var arr2 = []
							item.children.forEach(_item => {
								arr2.push({
									id: _item.id,
									text: _item.name
								})
							})
							var uitem = {
								id: item.id,
								text: item.name,
								children: arr2
							}
							arr.push(uitem)
						})
						this.columns8 = arr
						// console.log("----", this.columns8)
						
					}
				})
		},
		showDialog(){
			this.isdialog = true
			this.searchContent = ''
			this.page = 1
			this.unionsList = [] 
			var data = {
				name: this.searchContent,
				page: this.page,
				page_size: this.page_size,	
			}
			this.getConfigUnions(data)
		},
		addUnionsDialog(){
			this.isdialog2 = true
			this.new_unions = ''
		},
		// 获取工会列表
		getConfigUnions(data){
			this.$api.unions
				.getConfigUnions(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						this.unionsList = this.unionsList.concat(res.data.list)
					}
				})
		},
		// 工会滚动到底部加载更多
		scrollEvent(e){
			// console.log("000000")
			if (e.srcElement.scrollTop + e.srcElement.clientHeight == e.srcElement.scrollHeight ) {
				console.log("嘿嘿我在底部触发了")
				this.page = this.page + 1
				var data = {
					name: this.searchContent,
					page: this.page,
					page_size: this.page_size,	
				}
				this.getConfigUnions(data)
			}
		},
		// 搜索工会
		onSearch(val){
			// this.page = 1
			// this.searchContent = ''
			this.page = 1
			this.unionsList = [] 
			var data = {
				name: this.searchContent,
				page: this.page,
				page_size: this.page_size,	
			}
			this.getConfigUnions(data)
			console.log('000', val, this.searchContent)
		},
		// 搜索企业
		onSearch3(val){
			// this.page = 1
			// this.searchContent = ''
		
			this.unionsList3 = [] 
			var data = {
				name: this.searchContent3,	
			}
			this.getConfigUnions3(data)
			console.log('000', val, this.searchContent)
		},
		// 获取企业列表
		getConfigUnions3(data){
			this.$api.unions
				.getQCCData(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						this.unionsList3 = this.unionsList3.concat(res.data)
					}
				})
		},
		// 弹出企业弹窗
		showDialog2(){
			this.isdialog3 = true
			this.searchContent3 = ''
			this.unionsList3 = [] 
			// var data = {
			// 	name: this.searchContent3,	
			// }
			// this.getConfigUnions3(data)
		},
		// 点击某个企业确定
		selectedUnions3(item){
			console.log('---', item)
			// unionsname: '',
			// unionsid: '',
			this.companyname = item.name
			// this.unionsid = item.id
			this.isdialog3 = false
		},
		// 点击某个工会确定
		selectedUnions(item){
			console.log('---', item)
			// unionsname: '',
			// unionsid: '',
			this.unionsname = item.name
			this.unionsid = item.id
			this.isdialog = false
		},
		// 新增工会
		comfirmInfo(){
			if(this.new_unions.trim() == ''){
				this.$toast({
					type: 'fail',
					message: '工会名不能为空!',
					// duration: 0
				});
				return
			}
			var data = {
				name: this.new_unions
			}
			this.$api.unions
				.addUnions(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						this.page = 1
						this.unionsList = [] 
						this.searchContent = ''
						var data = {
							name: this.searchContent,
							page: this.page,
							page_size: this.page_size,	
						}
						this.getConfigUnions(data)
						this.isdialog2 = false
					}
				})
			
			
		},
		
		
		setUrl(res) {
		  let data = JSON.parse(res)
		  console.log(data)
		  this.url = data[0]  
		},
		onClick(name, title) {
			if(this.active == 1){
				this.$router.push({
					name: 'unionslist'
				})
			}
		},
		
		onConfirm(value) {
			this.unionsname = value;
			this.showPicker = false;
		},
		onConfirm2(value) {
			this.company_nature = value;
			this.showPicker2 = false;
		},
		onConfirm3(value) {
			this.company_scale = value;
			this.showPicker3 = false;
		},
		onConfirm4(values) {
			this.address_01 = values
				.filter((item) => !!item)
				.map((item) => item.name)
				.join('/');
				console.log('this.address_01', this.address_01)
			this.showArea = false;
		},
		onConfirm5(time) {			
			console.log("---", this.formatDate(time))
			this.date01 = this.formatDate(time)
			this.showPicker4 = false;
		},
		onConfirm8(value, index){
			console.log('-0-0', value, index, this.columns8[index[0]].children[index[1]].id)
			
			this.industry = `${value[0]}/${value[1]}`
			this.industry_id = this.columns8[index[0]].children[index[1]].id
			
			this.showPicker8 = false;
		},
		onSubmit(values) {
			if(this.companyname == ''){
				this.$toast({
					type: 'fail',
					message: '企业不能为空!',
					// duration: 0
				});
				return
				
			}
			if(this.unionsname == ''){
				this.$toast({
					type: 'fail',
					message: '所属工会不能为空!',
					// duration: 0
				});
				return
				
			}
			// if(this.id != ''){
			// 	this.showForm = false
			// 	return
			// }
			// companyname: '',
			// unionsname: '',
			// unionsid: ''
			// company_nature: '',
			// company_scale: '',
			// company_num: '',
			// company_contactname:'',
			// company_contactmobile: '',
			// company_contactemail: '',
			// industry: '',
			// address_01: '',
			// address_detail: '',
			var data = {
				id: this.id,
				company_name: this.companyname,
				organize_name: this.unionsname,
				organize_id: this.unionsid,
				type: this.company_nature,
				company_scale: this.company_scale,
				person_num: this.company_num,
				contact: this.company_contactname,
				contact_mobile: this.company_contactmobile,
				contact_email: this.company_contactemail,
				industry: this.industry,
				industry_id: this.industry_id,
				district: this.address_01,
				company_address: this.address_detail,
				mobile: localStorage.getItem('mobile'),
				
			}
			// console.log('-1-1-1-', data)
			// return
			this.$api.unions
				.submitFirstUnionsData(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						this.id = res.data.id
						this.showForm = false
					}
				})
			
			console.log('submit', this.address_01);
		},
		
		onConfirm01(values){
			this.apply_type = values;
			this.showPicker01 = false;
		},
		
		
		
		onSubmit2(values) {	
			if(this.checked == false){
				this.$toast({
					type: 'fail',
					message: '请勾选同意驿站运营承诺书!',
					duration: 2000
				});
				return
			}
			// measure: '',
			// date01: '',
			// apply_type: '',
			// address01: '',
			// checkboxGroup: [],
			// deviceinput: '',
			// url: '',
			// console.log('-000-', this.checkboxGroup)
			// return
			var data = {
				id: this.id,
				area: this.measure,
				build_start_time: this.date01,
				stadium_scale: this.apply_type,
				stadium_address: this.address01,
				equipment: this.checkboxGroup,
				old_equipment: this.deviceinput,
				business_license: this.url,
				mobile: localStorage.getItem('mobile'),
				
			}
			
			this.$api.unions
				.submitSecondUnionsData(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						this.$toast({
							type: 'success',
							message: '提交成功!',
							duration: 2000
						});
						setTimeout(() => {
							this.$router.push({
								name: 'unionslist'
							})
							
						}, 2100)
					}
				})
			console.log('submit', this.address_01);
		},
		backBtn(){
			this.showForm = true
		},
		
		
		formatter(type, val) {
			if (type === 'year') {
				return val + '年';
			}
			if (type === 'month') {
				return val + '月';
			}
			if (type === 'day') {
				return val + '日';
			}
			return val;
		},
		formatDate(date){
			let time = new Date(date)
			let year = time.getFullYear()
			let month = time.getMonth() + 1 > 9 ? (time.getMonth() + 1) : '0' + (time.getMonth() + 1)
			let day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
			let hour = time.getHours() > 9 ? time.getHours() : '0' + time.getHours()
			let minute = time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes()
			let second = time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds()
			// let data = `${year}-${month}-${day} ${hour}:${minute}:${second}`
			let data = `${year}-${month}-${day}`
			return data
		},
		
	}
}
</script>

<style lang="less" scoped>
@import './index.less';

* { touch-action: pan-y; }

.tabsList{
	/deep/ .van-tabs__nav--card{
		margin: 0;
	}
}
.box{
	box-sizing: border-box;
	padding: .1rem;
}
</style>
